import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const createTargetManualy = createAsyncThunk(
  "createTargetManualy",
  async (audienceData, thunkAPI) => {
    try {
      const formattedAudienceData = {
        name: audienceData.name,
        selectionConfig: {
          userStatus: audienceData.selectionConfig.userStatus,
          osType: audienceData.selectionConfig.osType,
          profile: audienceData.selectionConfig.profile,
          product: audienceData.selectionConfig.product,
          timeRange: {
            startDate: audienceData.selectionConfig.timeRange.startDate,
            endDate: audienceData.selectionConfig.timeRange.endDate,
          },
          generations: audienceData.selectionConfig.generations,
          genders: audienceData.selectionConfig.genders,
          app: audienceData.selectionConfig.app,
          locations: audienceData.selectionConfig.locations
        }
      };

      const apiClient = new APIClient();
      const response = await apiClient.post("/api/v1/management/audience/target/create", formattedAudienceData);

      return response.data;
    } catch (error) {
      console.error('API call error:', error.message);
      throw error;
    }
  }
);

  

  export const createTargetManualySlice = createSlice({
    name: "createTargetManualySlice",
    initialState: {
      loading: false,
      payload: {}, 
      error: null,
      status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(createTargetManualy.pending, (state) => {
          state.loading = true;
          state.status = 'loading';
        })
        .addCase(createTargetManualy.fulfilled, (state, action) => {
          state.loading = false;
          state.payload = action.payload;
          state.status = 'succeeded';
        })
        .addCase(createTargetManualy.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
          state.status = 'failed';
        });
    },
  });
  
  export default createTargetManualySlice.reducer;
